import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as fuiRedux from "../../../redux/fui/index";
import {
    fetchExternalClientDetails,
    checkIsWBSEValid
} from "../../../redux/fui/index";
import { Avatar, DialogActions } from "@material-ui/core";
import {
    StyledTooltip,
    TextHelperWrapper,
    TextHelperTypography,
    StyledRadioGroup,
    TopRadioWrapper,
    ConfigurationFormLabel,
} from "../FuiStyles";
import {
    longTextEndDate,
    rootExistedHint,
    rootWrongFormatHint,
    quickConfigurationTextHelper,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import TextsmsIcon from "@material-ui/icons/Textsms";
import {
    checkServiceNowTicket,
    checkWBSECode,
    checkBenefitsExpected,
    checkConcurrentUsers,
    checkMonthlyTicketVolume,
    checkPOCname,
    createMaxDate
} from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import BundleOrderApps from "./BundleOrderApps";
import { Grid, FormControlLabel, Radio } from "@material-ui/core";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { isValid } from "date-fns";
import { FlashOnRounded, FormatColorReset } from "@material-ui/icons";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";

const aSelectedInstanceFields = {
    DMSId: { type: "string", fieldName: "dmsId" },
    ClientName: { type: "string", fieldName: "clientName" },
    DeployRegion: { type: "object", fieldName: "deployRegion" },
    SAPContractID: { type: "object", fieldName: "sapContractId" },
    AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};
/**
 * AD Platform Form
 * @author Poornna Aiswarya Ganeshan
 * @version 1.0
 * @see Used in component: PlatformLicenseStepper
 */

const ADPlatform = ({
    values, // the value would be changed by user's input
    updateADForm, //the function to update AD values which is from redux
    updateASelectedInstanceByField,
    createdBy, // user's EID
    checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
    isRootExist, // the value that show whether DomainContextRoot exist or not from redux
    setIsAllValid, // the function to check whether all validations are satisfieds
    selectedEnvironment,
    minDate,
    maxDate,
    isServiceEndDateInvalid,
    getSelectedEnvironment,
    getServiceEndDate,
    getNotesValue,
    //   getUsersValue,
    //   userValidations,
    notesValidations,
    configurationType,
    classes,
    history,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    formClickSubmit,
    checkIsWBSEValid,
    isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

    // open the dialog when user choose Yes in GDPR
    const config = configurationType === "quick";
    const [isMonthlyTicketVolumeValid, setIsMonthlyTicketVolumeValid] = useState(
        true
    );

    // check whether values are valid
    const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    // check whether WBSECode is equal to MD & I WBSE
    const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
    const [isProjectNameValid, setIsProjectNameValid] = useState(true);
    const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
    const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
    const [selectedApps, setSelectedApps] = useState([]);
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");
    const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
    //   const [isUsersFieldValid, setUsersField] = useState(false);
    const [isNoteVisible, setNoteVisible] = useState(true);

    const isGDPR = values.GDPR === "yes";
    const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
    const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
    const [env, setEnv] = useState("");

    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [isPocvalid, setPocvalid] = useState(true);
    const [isPlanInputValid, setIsPlanInputValid] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const handleContractAvailabilityChange = (event) => {
        const value = event.target.value;
        setIsChecked(value === "yes");
        // updateADForm("IsContractIdAvailable", value);
        if (value === "no") {
            updateADForm("IsContractIdAvailable", "no")
            updateADForm("SAPContractID", "0000000000")
            updateADForm("EndToEndUId", "")
            setSapContractCodeLength(10)
            setPocvalid(false);
        } else {
            setPocvalid(true);
            updateADForm("SAPContractID", "")
            // updateADForm("ClientName", "")
            updateADForm("EndToEndUId", "")
            setSapContractCodeLength(0)
        }
    };


    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
    }, [config]);

    if (config) {
        //updateADForm("ClientName", "")
        updateADForm("EndToEndUId", "")
        updateADForm("Company", "")
        updateADForm("AvanadeCountry", "")
        updateADForm("AccentureCountry", "")
        updateADForm("ContractAvailabilityDate", "")
    }

    if (!config) {
        if (externalClientData.length > 0) {
            updateADForm("ClientName", externalClientData[0])
            updateADForm("EndToEndUId", externalClientData[1])
            if (externalClientData[2] !== undefined)
                updateADForm("Company", externalClientData[2])
            if (externalClientData[3] !== undefined)
                updateADForm("AvanadeCountry", externalClientData[3])
            if (externalClientData[4] !== undefined)
                updateADForm("AccentureCountry", externalClientData[4])
            if (isChecked && externalClientData[5] !== undefined)
                updateADForm("GDPR", externalClientData[5] ? "yes" : "no")
            updateADForm("ContractAvailabilityDate", "")
            updateADForm("IsContractIdAvailable", "yes")
        }
    }

    if (!config) {
        (isConcurrentUsersValid ||
            isBenefitsExpectedValid) &&
            !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected && isPocvalid
            ? setIsAllValid(true)
            : setIsAllValid(false);
    } else {
        (isServiceNowTicketValid ||
            isConcurrentUsersValid ||
            isBenefitsExpectedValid) &&
            !isServiceEndDateInvalid && isWBSEValid && isWBSECodeMDIValid && isProjectNameValid && isTeamNameSelected
            ? setIsAllValid(true)
            : setIsAllValid(false);
    }

    // get user's input
    const handleChange = (event, fieldName) => {
        if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
            updateADForm(fieldName, event);
            getServiceEndDate(event);
        }
        else if (fieldName === "TeamName") {
            if (event !== undefined || event !== null) {
                updateADForm(fieldName, event);
                setIsTeamNameSelected(true);
                if (values.TeamName !== "Others") {
                    updateADForm("TeamNameOthers", "")
                }
            } else {
                setIsTeamNameSelected(false);
            }
        }
        else {
            const { value } = event.target;
            event.preventDefault();
            updateADForm(fieldName, value);
            // if (fieldName === "Environment") {
            // getSelectedEnvironment(value);
            // }
            if (fieldName === "RITM") {
                setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
            }
            if (fieldName === "WBSEcode") {
                const wbsevalue = value.toUpperCase()
                if (wbsevalue.trim() === "CBYDQ001") {
                    setIsWBSECodeMDIValid(false)
                }
                // setIsWBSECodeValid(checkWBSECode(value));
                const isWBSEFormatValid = checkWBSECode(value);
                if (isWBSEFormatValid) {
                    checkIsWBSEValid(value)
                }

            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "ProjectName") {
                if (value.length > 32 || value.length < 3) {
                    setIsProjectNameValid(false)
                } else {
                    setIsProjectNameValid(true)
                }
            }
            if (fieldName === "ConcurrentUsers") {
                setIsConcurrentUsersValid(checkConcurrentUsers(value));
            }
            if (fieldName === "BenefitsExpected") {
                if (value[0] === "0") {
                    setIsBenefitsExpectedValid(false);
                } else {
                    setIsBenefitsExpectedValid(checkBenefitsExpected(value));
                }
            }
            if (fieldName === "RequestNotes") {
                if (value.length > 0 && value.length < 247) {
                    getNotesValue({ emptyString: false, maxLength: false });
                } else if (value.length === 0) {
                    getNotesValue({ emptyString: true, maxLength: false });
                } else if (value.length > 246) {
                    getNotesValue({ emptyString: false, maxLength: true });
                }
            }

            if (fieldName === "TicketMonthlyVolume") {
                if (value[0] === "0") {
                    setIsMonthlyTicketVolumeValid(false);
                } else {
                    setIsMonthlyTicketVolumeValid(checkMonthlyTicketVolume(value));
                }
            }
            //update aSelectedInstance as other step relies on this data
            if (aSelectedInstanceFields[fieldName]) {
                const afieldDetails = aSelectedInstanceFields[fieldName];
                afieldDetails.type === "string" &&
                    updateASelectedInstanceByField({
                        field: afieldDetails.fieldName,
                        value,
                    });
                afieldDetails.type === "object" &&
                    updateASelectedInstanceByField({
                        field: afieldDetails.fieldName,
                        value: {
                            Value: value,
                        },
                    });
            }
            if (fieldName === "SAPContractID") {
                let sapLength = value.length
                setSapContractCodeLength(sapLength)
                if (sapLength == 10) {
                    fetchExternalClientDetails(value)
                }
            }
            if (fieldName === "GDPR" && value === "yes") {
                updateADForm("DeploymentRegion", "");
            }
            if (fieldName === "DeploymentRegion") {
                if (value == "sydney") {
                    setRegionCode("dh")
                } else if (value == "virginia") {
                    setRegionCode("dh1")
                } else if (value == "frankfurt") {
                    setRegionCode("dh2")
                } else if (value == "singapore") {
                    setRegionCode("dh3")
                } else if (value == "tokyo") {
                    setRegionCode("dh4")
                } else if (value == "ireland") {
                    setRegionCode("dh5")
                } else if (value == "london") {
                    setRegionCode("dh6")
                } else {
                    setRegionCode("[__]")
                }
            }
            if (fieldName === "DataClassification") {
                if (value === "Client-Production" || value === "Internal-Production") {
                    setEnv("Production")
                } else if (value === "Client-NonProduction") {
                    setEnv("Test")
                    updateADForm("Tier", "")
                } else if (value === "AppTeam-Development") {
                    setEnv("Dev")
                    updateADForm("Tier", "")
                } else if (value === "AppTeam-Testing") {
                    setEnv("Test")
                    updateADForm("Tier", "")
                } else {
                    setEnv("")
                    updateADForm("Tier", "")
                }
            }


        }
    };

    const apps = "AD,ATR,Quasar++";
    const appList = apps.split(",");
    const sortedAppList = appList.sort();

    // user can only input lower case letter and numbers in DomainContextRoot
    const handleChangeRoot = (event, fieldName) => {
        const re = /^[a-z0-9]*$/;
        const value = event.target.value;
        re.test(value) && updateADForm(fieldName, value);
        setDomainContextRoot(value)
    };

    const handleChangeRootSuggestions = (event, value, fieldName) => {
        const re = /^[a-z0-9]*$/;
        // const value = event.target.value;
        re.test(value) && updateADForm(fieldName, value);
        setDomainContextRoot(value)
    };


    // it would check whether the root has existed from DB once user stop typing longer than 0.3s
    const debouncedValue = useDebounce(domainContextRoot, 300);
    useEffect(() => {
        debouncedValue && checkDomainAvaliable(debouncedValue);
    }, [debouncedValue]);


    const handleChangeMobileNo = (event, fieldName) => {
        const re = /^[0-9]{0,}$/;
        const value = event.target.value;
        re.test(value) && updateADForm(fieldName, value);
    };

    updateADForm("ConfigurationType", configurationType);
    getSelectedEnvironment(env);
    updateADForm("Environment", env);

    //form validation
    const validateInputFields = (step) => {
        let ispass = true;
        const fieldsRequired = {
            'step0': [
                'ProjectName',
                'WBSEcode',
                'SecondaryPOC',
                'DataClassification',
                'TeamName',
                'RequestNotes',
            ],

            'step1': [
                'DeploymentRegion',
                'DomainContextRoot',
                'Environment',
            ],

            'step2': [
                'AdminDistributionGroup',
                'TentativeServiceEndDate',
            ]
        }

        if (config) {
            //fieldsRequired['step0'].push('ClientNameInternal');
        } else {
            if (isChecked)
                fieldsRequired['step0'].push('SAPContractID');
            else {
                fieldsRequired['step0'].push('Pocdetails', 'ClientName', 'RITM');
            }
            fieldsRequired['step2'].push('UsersDistributionGroup');
        }

        for (const fieldname of fieldsRequired[step]) {
            if (fieldname === "WBSEcode" && !isWBSEValid) {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
                ispass = false;
            } else if (values[fieldname] === "") {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
                ispass = false;
            } else {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "";
            }
        }

        if (step === 'step2' && ispass)
            formClickSubmit();
        else
            return ispass;
    }

    return (
        <>
            <GeneralForm
                isPlanInputValid={isPlanInputValid}
                FormId={2}
                validateInputFields={validateInputFields}
                ClientContractFields={

                    <div>
                        {!config ?
                            <TopRadioWrapper>
                                <ConfigurationFormLabel component="legend">
                                    Is a contract ID available?
                                </ConfigurationFormLabel>


                                <StyledRadioGroup
                                    aria-label="contract-available"
                                    name="contract-available"
                                    value={isChecked ? "yes" : "no"}
                                    onChange={handleContractAvailabilityChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="primary" />}
                                        label="YES"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="primary" />}
                                        label="NO"
                                    />
                                </StyledRadioGroup>
                            </TopRadioWrapper>
                            : ""}

                        {(!isChecked && !config) &&
                            <div style={{ fontSize: "small", color: "#0041F0" }}>
                                <em>
                                    To proceed with provisioning without a Contract ID, please provide the following mandatory details
                                </em>
                                <ul>
                                    <li>WBSE Code (used for chargeback if contract is not provided)</li>
                                    <li>Opportunity ID (for deal tracking and reference)</li>
                                    <li>Expected Contract Availability Date (must be within 28 days)</li>
                                    <li>Client Point of Contact (name and email for contract follow-up)</li>
                                </ul>
                            </div>
                        }

                        < div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                {(!config && isChecked) ?
                                    <Grid item xs={4}>
                                        {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                                    </Grid>
                                    : (!config && !isChecked) ?
                                        <Grid item xs={4}>
                                            {FormField.Pocvalid(handleChange, values, isPocvalid)}
                                        </Grid>
                                        : <></>
                                }
                                {(!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError) &&
                                    <Grid item xs={4}>
                                        {PlatformFormField.ClientNamePlatformField(
                                            values,
                                            handleChange,
                                            externalClientData[0]
                                        )}
                                    </Grid>
                                }
                                {!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError && (
                                        <Grid item xs={4}>
                                            {PlatformFormField.EndToEndUIdPlatformField(
                                                values,
                                                handleChange,
                                                externalClientData[1]
                                            )}
                                        </Grid>
                                    )
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        <StyledTooltip
                                            title={longTextEndDate}
                                            placement="left-start"
                                            noValidate
                                        >
                                            <DateTextFieldCommonComponent
                                                tentativeServiceEndDate={values.ContractAvailabilityDate}
                                                minDate={0}
                                                maxDate={createMaxDate(28)}
                                                handleChange={handleChange}
                                                idkey="ContractAvailabilityDate"
                                                label="Contract Availability Date"
                                            />
                                        </StyledTooltip>
                                    </Grid>
                                }
                                {(!config) &&
                                    <Grid item xs={4}>
                                        {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                                    </Grid>
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        {FormField.ClientNamePlatformInternal(handleChange, values)}
                                    </Grid >}
                                <Grid item xs={4}>
                                    {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                                </Grid >
                                {config &&
                                    <Grid item xs={4}>
                                        {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                                    </Grid>
                                }
                                <Grid item xs={4}>
                                    {FormField.SecondaryContact(handleChange, values, config)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.DataClassificationField(handleChange, values, configurationType)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.TeamNamesField(handleChange, values, isTeamNameSelected,'adPlatform')}
                                </Grid >
                                {values.TeamName === "Others" &&
                                    <Grid item xs={4}>
                                        {FormField.TeamNameOthers(handleChange, values)}
                                    </Grid >
                                }
                                {
                                    (config &&
                                        <Grid item xs={4}>
                                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                                        </Grid>
                                    )
                                }
                                {/* <Grid item xs={4}>
                                {config &&
                                    FormField.ClientNamePlatformInternal(handleChange, values)}
                            </Grid > */}

                                <Grid item xs={12}>
                                    {PlatformFormField.RequestNotesPlatformField(
                                        values,
                                        handleChange,
                                        notesValidations
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                EnvironmentFields={
                    <div>
                        {!config ? <p> Expected Custom AD UI URL: <span style={{ color: " #0041F0" }}>https://genwizard-{domainContextRoot}.mywizard-aiops.com </span></p> : ""}
                        {!config ? <p> Expected Custom AD API URL: <span style={{ color: " #0041F0" }}>https://genwizard-{domainContextRoot}-api.mywizard-aiops.com </span></p> : ""}
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {PlatformFormField.GDPRPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        classes,
                                        config,
                                        isChecked
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.DeploymentRegionGenWizardPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                                        values,
                                        handleChangeRootSuggestions,
                                        // handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        rootWrongFormatHint,
                                        externalClientData,
                                        domainContextRoot,
                                        isLoading
                                    ) : PlatformFormField.DomainContextRootPlatformField(
                                        values,
                                        handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        isLoading
                                    )}
                                </Grid>
                                {/* <Grid item xs={3}>
                                    {PlatformFormField.EnvironmentPlatformField(values, handleChange)} */}
                                <Grid item xs={3}>
                                    {PlatformFormField.EnvironmentField(values, handleChange, env)}
                                </Grid>
                                {/* {values.Environment === "Production" &&
                                    <Grid item xs={3}> {PlatformFormField.TierPlatformField(values, handleChange)}</Grid>} */}
                            </Grid>
                        </div>
                    </div>
                }

                ApplicationFields={
                    <div style={{ flexGrow: 1 }}>
                        <Grid
                            container
                            spacing={2}
                        >

                            <Grid item xs={6}>
                                {FormField.AdminDistributionGroupField(handleChange, values)}
                            </Grid>
                            {!config &&
                                <Grid item xs={6}>
                                    {FormField.UsersDistributionGroupField(handleChange, values)}
                                </Grid>}
                            <Grid item xs={6}>
                                <StyledTooltip
                                    title={longTextEndDate}
                                    placement="left-start"
                                    noValidate
                                >
                                    <DateTextFieldCommonComponent
                                        tentativeServiceEndDate={values.TentativeServiceEndDate}
                                        selectedEnvironment={selectedEnvironment}
                                        isServiceEndDateInvalid={isServiceEndDateInvalid}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        handleChange={handleChange}
                                    />
                                </StyledTooltip>
                            </Grid>
                        </Grid>
                    </div>
                }
                LeftColumnFields={
                    <div>
                    </div>
                }
                RightColumnFields={
                    <div>
                    </div>
                }
                history={history}
            ></GeneralForm>
            {!isChecked && (
                <CommonDialogV2
                    open={isNoteVisible}
                    onClose={() => setNoteVisible(false)}
                    title={"Note"}
                    textContent={
                        <div>
                            <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
                            <ul>
                                <li>
                                    Provisioned services will be automatically stopped
                                </li>
                                <li>
                                    Cost recovery will be initiated using the provided WBSE code
                                </li>
                            </ul>
                        </div>
                    }
                    dialogActions={
                        <DialogActions>
                            <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
                        </DialogActions>
                    }
                ></CommonDialogV2>
            )}
        </>
    );
};

const MSTP = (state, ownProps) => ({
    values: state.fui.ADForm,
    isRootExist: state.fui.isRootExist,
    isWBSEValid: state.fui.isWBSEValid,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
    updateADForm: fuiRedux.updateADForm,
    updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
    checkDomainAvaliable: fuiRedux.checkRootExisted,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(ADPlatform));
